module.exports = __webpack_public_path__ + "img/4-2.4eb40720.svg";